import { error as logError } from '../../../abt-utils/logger'
import { applyDefault } from '../../../abt-utils/structure'

export function a (test) {
  var context = {
    recipe: 'a',
    test: test
  }

  return System.import('./shared')
    .then(applyDefault(context))
    .catch(logError)
}

export function b (test) {
  var context = {
    recipe: 'b',
    test: test
  }

  return System.import('./shared')
    .then(applyDefault(context))
    .catch(logError)
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt513/large/index.js
 ** module id = 50
 ** module chunks = 2
 **/